import React, { useEffect, useState } from 'react'
import { addRemoveBookmark, getBlog, likeUnlikeBlog } from '../services/BlogService';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useCookies } from 'react-cookie'
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import { red } from '@mui/material/colors';
import parser from 'html-react-parser'
import '../style/blog.css'
import { CircularProgress, Divider, IconButton } from '@mui/material';
import {AccountCircle, ArrowCircleUp, BookmarkAdd, BookmarkAdded, Comment, Favorite, FavoriteBorder} from '@mui/icons-material';
import CommentsDrawer from './comment/CommentsDrawer';

export default function Blog() {
  const [content, setContent] = useState()
  const [tags, setTags] = useState([])
  const [readingTime, setReadingTime] = useState([])
  const [authorId, setAuthorId] = useState()
  const [authorName, setAuthorName] = useState()
  const [publishedDate, setPublishedDate] = useState([])
  const [likes, setLikes] = useState(0)
  const [isLiked, setIsLiked] = useState(false)
  const [isBookmarked, setIsBookmarked] = useState(false)
  const [openCommentDrawer, setOpenCommentDrawer] = useState(false)
  const [cookies, setCookies, removeCookies] = useCookies()
  const {id} = useParams()
  const [isLoading, setIsLoading] = useState(true)
  const navigate = useNavigate()
  const currentUserID = cookies['userId']

  const createTokenHeader = () =>{
    if(!cookies['accessToken']){
        navigate('/login')
        return
    }
    const token = cookies['accessToken'].access_token
    const _headers = {"Authorization" : `Bearer ${token}`}
    return _headers
  }

  const handleLike = (event) =>{
    const _headers = createTokenHeader()
    const blogId = {
      blogId: id
    }
    likeUnlikeBlog(blogId, _headers)
    .then((res)=>{
      console.log(res.data)
    })
    .catch((err)=>{
      console.log(err)
    })
    if(!isLiked){
      setIsLiked(true)
      setLikes(likes+1)
    }else{
      setIsLiked(false)
      setLikes(likes-1)
    }
  }

  const handleCommentDrawer = () =>{
    setOpenCommentDrawer(true)
  }

  const handleBookmark = () =>{
    const _headers = createTokenHeader()
    const blogId = {
      blogId: id
    }
    addRemoveBookmark(blogId, _headers)
    .then((res)=>{
      console.log(res.data)
    })
    .catch((err)=>{
      console.log(err)
    })
    if(!isBookmarked){
      setIsBookmarked(true)
    }else{
      setIsBookmarked(false)
    }
  }

  function getHeaderObjectForFetchtingBlog(){

    if(cookies['accessToken']){
      const token = cookies['accessToken'].access_token
      const _header = `Bearer ${token}`
      return [true, _header]
    }
    return [false, null]
  }

  useEffect(()=>{
    setIsLoading(true)
    const [isHeaderPresent, header] = getHeaderObjectForFetchtingBlog()

    const _header = {
      isHeaderPresent: isHeaderPresent,
      header: header
    }
    getBlog(id, _header)
    .then((res)=>{
      console.log(res.data)
      const blogContent = parser(res.data.blogContent)
      setContent(blogContent)
      setTags(res.data.tags)
      setLikes(res.data.likes.length)
      setIsLiked(res.data.isLikedByCurrentUser)
      setIsBookmarked(res.data.isBookmarkedByCurrentUser)
      setReadingTime(res.data.readingTime)
      setPublishedDate(res.data.publishedDateTime)
      setAuthorId(res.data.authorId)
      setAuthorName(res.data.authorName.trim())
      setIsLoading(false)
    })
    .catch((err)=>{
      if(err.response.status == 404){
        navigate("/notFound")
      }else{
        console.log("Server unavailable: " + err)
      }
      setIsLoading(false)
    })
  }, [id])

  const scrollToTop = () =>{ 
    window.scrollTo({ 
      top: 0,  
      behavior: 'smooth'
    }); 
  }; 

  return (
    <>
    {isLoading && <CircularProgress/>}
    <div className='ProseMirror blog'>
      <Link className='author-details' to={`/account/${authorId}`}>
        <div className='author-blog-details'>
            <div className='author-pic'>
              <IconButton>
                <AccountCircle sx={{ fontSize: 50 }}/>
              </IconButton>
            </div>
            <div className='author-name-blog-details'>
              <div className='author-name'>{authorName}</div>
              <div className='blog-details'>{readingTime} | {publishedDate}</div>
            </div>
        </div>
      </Link>
      <div >
        {content}
      </div>
      <div className='tagList'>
        {tags &&
          <Stack direction="row" spacing={1}>
            {
              tags.map((tag)=>(
                <Chip label={tag} key={tag}/>
              ))
            }
          </Stack>
        }
      </div>
      <Divider/>
      <div className='blog-options'>
        <div className='blog-options-left'>
        <div>
          <IconButton onClick={handleLike} style={{cursor: 'pointer'}}>
            {isLiked ? <Favorite sx={{ color: red[500] }} /> : 
            <FavoriteBorder />}
          </IconButton>
        </div>
        <div className='likes-count'>
          {likes}
        </div>
        <div>
          <IconButton onClick={handleCommentDrawer} style={{cursor: 'pointer'}}>
            <Comment />
          </IconButton>
        </div>
        <IconButton onClick={handleBookmark} style={{cursor: 'pointer'}}>
          {isBookmarked ? <BookmarkAdded/> : 
            <BookmarkAdd/>}
          </IconButton>
          </div>
          <div className='blog-options-right'>
            <IconButton onClick={scrollToTop} style={{cursor: 'pointer'}}>
              <ArrowCircleUp/>
            </IconButton>
          </div>
      </div>
    </div>
    <CommentsDrawer openCommentDrawer={openCommentDrawer} setOpenCommentDrawer={setOpenCommentDrawer} blogId={id} currentUserId={currentUserID}/>
    </>
  )
}
